import $ from 'jquery';
import ScrollMagic from "ScrollMagic";
import 'debug.addIndicators';
import layerOlderAge from '../libs/layer-older-age';

export default () => {


    $(window).on('load', function () {

        console.log('lottie loader');
        // setTimeout(function () {
            $('body').removeClass('fixed');
            $('#lottie').fadeOut();
            layerOlderAge();
        // }, 1000);

    });
};



// WEBPACK FOOTER //
// ./scripts/libs/loader.js